import { Component, OnDestroy, OnInit, HostListener } from '@angular/core';
import { BasePageComponent } from '../../commons/base-page/base-page.component';
import { HelpersService } from '../../../core/helpers/helpers.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ContentP, ContentMetadataP } from '../../../data/360-client-api';
import { VodDataRestService } from '../../../data/vod/vod-data-rest.service';
import { Subscription } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MetaService } from '../../../data/meta/meta.service';
import * as is from 'is_js';
import { Location } from '@angular/common';
import { HomescreenVodsP, HomescreenVodsOpt } from '../../../data/cms-vod-client-api';
import { isNullOrUndefined } from 'util';
import { ContentExtended } from '../../../data/vod/models/contentExtended';
import { Title } from '@angular/platform-browser';
import { DataSharingService } from '../../../core/data-sharing/data-sharing.service';
import { SeoService } from '../../../data/seo/seo-service.service';

declare var videojs;
declare var $: any;


@Component({
  selector: 'app-content-detail',
  templateUrl: './content-detail.component.html',
  styleUrls: ['./content-detail.component.css']
})
export class ContentDetailComponent extends BasePageComponent implements OnInit, OnDestroy {

  public movie: ContentMetadataP;
  public content: ContentP;
  private player: any = null;
  public isAutoPlay = true;
  posterCatalog: string;
  isSerie: boolean = false;
  isEpisode: boolean = false;
  seasons: ContentP[];
  isMobile: boolean;
  isDesktop: boolean;
  routerSubs: Subscription;
  summaryLong: string;
  isPlay: boolean = false;
  isVisible: boolean;
  // urls: string[] = ["https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8", "https://mnmedias.api.telequebec.tv/m3u8/29880.m3u8"];
  isRel: boolean = true;
  vods: HomescreenVodsOpt[] = [];
  selectedCatID: number;
  isFirst: boolean;
  nextVideoEl: HTMLElement;
  nextVideoButton: HTMLElement;
  cancelVideoButton: HTMLElement;
  cancelClicked: boolean;
  nextVod: ContentP = {};
  isLast: boolean;
  selectedCarouselID: string = null;
  selectedContentID: string = null;
  openedAccordions: any;
  id: string;

  constructor(helpers: HelpersService,
    private dataSource: VodDataRestService,
    private route: ActivatedRoute,
    private router: Router,
    private deviceService: DeviceDetectorService,
    private metaService: MetaService,
    private _location: Location,
    private dataSharing: DataSharingService,
    private seo: SeoService
  ) {
    super(helpers);
    this.isMobile = deviceService.isMobile();
    this.isDesktop = deviceService.isDesktop();
    this.routerSubs = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          dataSharing.setBoolTrue(true);
        }, 200);
        this.closeAllOpenAccordions();
        this.isRel = false;
        if (this.id) {
          this.destroyPlayer();
          this.getContent();
        }
        else if (!isNullOrUndefined(this.content)) {
          if (this.content.type == "SERIES") {
            this.getContent();
          }
        }
      }
    });

    dataSharing.carouselID$.subscribe(data => {
      if (data && this.router.url.includes('contentDetail')) {
        if (this.selectedCarouselID != null && (this.selectedCarouselID != data.carouselID)) {
          let detailClass = document.getElementById(this.selectedCarouselID)
          // let img = document.getElementById(this.selectedContent.id + '')
          let selectedItem = document.getElementById(this.selectedCarouselID + '' + this.selectedContentID)
          // img.style.visibility = 'hidden';
          selectedItem.classList.remove('selected');
          detailClass.classList.remove('accordion-opened');
          // this.dataSharing.sendCloseCarouse(data);
        }

        this.selectedCarouselID = data.carouselID;
        this.selectedContentID = data.contentID;

      }
    })


  }
  selectedItems: any;
  closeAllOpenAccordions() {
    this.openedAccordions = document.getElementsByClassName('accordion-opened');
    for (let item of this.openedAccordions) {
      item.classList.remove('accordion-opened');
    }

    this.selectedItems = document.getElementsByClassName('selected');
    for (let item of this.selectedItems) {
      item.classList.remove('selected');
    }
  }

  createPlayer() {
    setTimeout(() => {
      let playerDiv = document.getElementById('player-div');
      let videoTag = document.createElement("video");
      videoTag.setAttribute("class", "video-js vjs-big-play-centered")
      videoTag.setAttribute("id", "video-player");
      videoTag.setAttribute("playsinline", "");
      videoTag.setAttribute("webkit-playsinline", "");
      playerDiv.appendChild(videoTag);
      this.playPlayer();
    }, 150);
  }

  createTrailerPlayer() {
    setTimeout(() => {

      let playerDiv = document.getElementById('trailer-div');
      let videoTag = document.createElement("video");
      videoTag.setAttribute("class", "video-js vjs-big-play-centered")
      videoTag.setAttribute("id", "trailer-player");
      playerDiv.appendChild(videoTag);
      this.playTrailer()
    }, 150);
    // this.getContent();
  }

  ngOnInit() {
    // this.getContent();
    this.selectedCatID = +localStorage.getItem('selected_cat_id')
    if (isNullOrUndefined(this.selectedCatID) || this.selectedCatID == 0) {
      this.getActiveCategories();
    }
    else {
      this.getVodsForContentDetail();
    }
    let self = this;
    this.windowResize();
    $(window).resize(function () {
      self.windowResize();
    });

    window.addEventListener("beforeunload", (event) => {
      this.stopVod();
    });

  }

  ngAfterViewInit() {
    this.getContent();
  }

  getActiveCategories() {
    this.dataSource.getActiveCategories().subscribe(categories => {

      let mainCategory = categories[categories.findIndex(category => category.main)];
      this.selectedCatID = mainCategory.id;
      this.getVodsForContentDetail();
    })
  }

  windowResize() {
    if (screen.width > 1020) {
      this.isVisible = true;
    }
    else {
      this.isVisible = false;
    }

  }

  ngOnDestroy() {

    if (this.isPlay) {
      this.stopVod();
    }

    if (this.routerSubs) {
      this.routerSubs.unsubscribe();
    }
    this.destroyPlayer();

  }

  pageUrl: string
  getContent() {
    this.pageUrl = document.URL;
    this.id = this.route.snapshot.paramMap.get('id');
    this.dataSource.getSingleContent(+this.id)
      .subscribe(content => {
        this.content = content;
        //this.metaService.updateTitle(this.content.metadata.title);
        //this.metaService.updateMetaInfo(this.content.metadata.summary_short);
        this.summaryLong = this.content.metadata.summary_long;
        this.posterCatalog = this.content.posters.find(poster => poster.posterDefinition.id == 2).url;
        this.isRel = true;
        if (this.content.type == 'SERIES') {
          this.isSerie = true;
          if (this.content.encodedTrailerUrl || this.content.externalTrailerUrl) {
            this.createTrailerPlayer();
          }
        }
        else {
          this.isSerie = false;
          if (content.transcodedMediaUrl)
            this.createPlayer();
        }
        if (this.content.type == 'EPISODE') {
          this.isEpisode = true;
        }
        else {
          this.isEpisode = false;
        }
        this.movie = this.content.metadata;
        this.seo.generateTags({
          title: this.content.metadata.title,
          description: this.content.metadata.summary_short,
          image: this.posterCatalog,
          slug: 'contentDetail/' + this.content.id + '/' + this.content.urlName,
          url: this.router.url,
        });
      });

  }



  getVodsForContentDetail() {
    this.dataSource.getVodsForContentDetail(this.selectedCatID).subscribe(data => {
      this.vods = data;
    })
  }

  nextTitle: string;
  nextPoster: string;

  playPlayer() {
    setTimeout(() => {
      if (!this.player) {
        this.player = videojs('video-player', {
          autoplay: this.isDesktop,
          controls: true,
          fluid: true,
          controlBar: {
            playToggle: {
              replay: true
            },
            volumePanel: {
              inline: false
            }
          }
          // nativeControlsForTouch: true
        });



        // this.player.src([
        //   { type: 'application/x-mpegURL', src: 'http://vod.sportstv.com.tr/C657CF4C-88E3-478B-972F-B848B5AB0A7E/HLS/SPORTSTV-OTT-HLS/master.m3u8' }
        // ]);
        this.player.src([
          { type: 'application/x-mpegURL', src: this.content.transcodedMediaUrl }
        ]);

        this.player.hlsQualitySelector();

        this.player.poster(this.posterCatalog);

        if (is.existy(this.content.thumbnailJsonUrl)) {
          this.dataSource.getThumbnails(this.content.thumbnailJsonUrl).subscribe(thumbnails => {
            this.player.thumbnails(thumbnails);
          })
        }

        // this.player.play();
        this.player.on('pause', () => {
          this.isPlay = false;
          this.stopVod()
        })
        this.player.on('play', () => {
          this.isPlay = true;
          this.startVod()
        })


        var thiz = this;
        this.player.one('loadedmetadata', function () {
          thiz.getNextVod();

        });

        $(document).keyup(function (e) {
          if (e.which === 37 && thiz.player) { //key press left arrow
            thiz.player.currentTime(thiz.player.currentTime() - 10)
          }

          if (e.which === 39 && thiz.player) { //key press right arrow
            thiz.player.currentTime(thiz.player.currentTime() + 10)
          }
        });

      }
      // else {
      //   // this.player.poster(`assets/images/movies/movie-single-${this.movie.external_id}.jpg`);

      //   this.player.src([
      //     { type: 'application/x-mpegURL', src: this.content.transcodedMediaUrl }
      //   ]);
      //   this.player.poster(this.posterCatalog);

      //   if (is.existy(this.content.thumbnailJsonUrl)) {
      //     this.dataSource.getThumbnails(this.content.thumbnailJsonUrl).subscribe(thumbnails => {
      //       this.player.thumbnails(thumbnails);
      //     })
      //   }

      //   $(document).keyup(function (e) {
      //     if (e.which === 37 && thiz.player) { //key press left arrow
      //       thiz.player.currentTime(thiz.player.currentTime() - 10)
      //     }

      //     if (e.which === 39 && thiz.player) { //key press right arrow
      //       thiz.player.currentTime(thiz.player.currentTime() + 10)
      //     }
      //   });
      // }
    });

  }

  getNextVod() {
    this.dataSource.getNextVod(this.content.id).subscribe(data => {
      if (data) {
        this.nextVod = data;
        this.nextPoster = this.nextVod.posters.find(poster => poster.posterDefinition.id == 2).url;
        this.nextTitle = this.nextVod.metadata.title;
        this.overlayPlayer();
      }
    })
  }

  jumpButton: HTMLElement;
  jumpBackButton: HTMLElement;

  overlayPlayer() {
    var thiz = this;
    this.player.overlay({
      overlays: [{
        // This overlay appears at 3 seconds and disappears at 15 seconds.
        content: `
        <div id="next-video-wrapper">
        
        <div id="next-video" class="next-video-box">
                    <div class="next-image-wrapper">
                      <img class="next-image" src="${this.nextPoster}">
                      
                    </div>
                    <div class="next-video-details">
                      <div class="next-video-title">${this.nextTitle}</div>
                      <div class="next-video-buttons">
                        <div id="cancel-button" class="next-button">İptal</div>
                        <div id="next-button" class="next-button">Devam Et</div>
                      </div>
                    </div>
                  </div>
                  <button id="mobile-cancel-button" type="button" class="cancel-next" style="opacity: 1; color:white">×</button>
                  </div>
                  
                  `,
        start: thiz.player.duration() - 10,
        end: thiz.player.duration(),
        align: 'bottom-right',
      },
      {
        content: `
        <div id="jump-right" class="jump-on-10">
          <i class="fa fa-repeat" style="color: rgba(199, 199, 199, 0.6)"></i>
          <div class="time-of-jump">10</div>
        </div>
                  
                  `,
        align: 'right',
        start: 0,
        end: this.isDesktop ? this.player.duration() : 0,
      },
      {
        content: `
        <div id="jump-left" class="jump-on-10">
          <i class="fa fa-rotate-left" style="color: rgba(199, 199, 199, 0.6)"></i>
          <div class="time-of-jump">10</div>
         </div>
        `,
        align: 'left',
        start: 0,
        end: this.isDesktop ? this.player.duration() : 0,
      }]
    });

    setTimeout(() => {
      this.listenNextVideoEl();
      this.jumpButton = document.getElementById('jump-right');
      this.jumpBackButton = document.getElementById('jump-left');

      this.jumpButton.addEventListener("click", event => {
        this.player.currentTime(this.player.currentTime() + 10);
      });

      this.jumpBackButton.addEventListener("click", event => {
        this.player.currentTime(this.player.currentTime() - 10);
      });

    }, 100);
  }

  timer: any
  mouseMoved() {
    if (this.isDesktop && !!this.player) {

      if (this.timer && this.jumpButton && this.jumpBackButton) {
        clearTimeout(this.timer);
        this.jumpButton.classList.remove('jump-on-10-hidden');
        this.jumpBackButton.classList.remove('jump-on-10-hidden');
      }

      this.timer = setTimeout(() => {

        this.jumpButton.classList.add('jump-on-10-hidden');
        this.jumpBackButton.classList.add('jump-on-10-hidden');
      }, 2200);
    }

  }

  mobileCancelButton: HTMLElement;
  nextVideoWrapper: HTMLElement;
  listenNextVideoEl() {
    var thiz = this;
    this.cancelClicked = false;
    this.nextVideoEl = document.getElementById('next-video');
    this.nextVideoWrapper = document.getElementById('next-video-wrapper');
    this.nextVideoButton = document.getElementById('next-button');
    if (!this.isDesktop) {
      this.mobileCancelButton = document.getElementById('mobile-cancel-button');
      this.mobileCancelButton.addEventListener("click", event => {
        this.cancelClicked = true;
        this.nextVideoWrapper.style.display = 'none';
        // this.mobileCancelButton.style.display = 'none !important';
      })
    }
    this.nextVideoButton.addEventListener("click", event => {
      this.router.navigateByUrl('contentDetail/' + this.nextVod.id + '/' + this.nextVod.urlName)
    })

    this.cancelVideoButton = document.getElementById('cancel-button');
    this.cancelVideoButton.addEventListener("click", event => {
      this.cancelClicked = true;
      this.nextVideoEl.style.display = 'none';
    })

    this.player.on('ended', function () {
      if (!thiz.cancelClicked) {
        thiz.router.navigateByUrl('contentDetail/' + thiz.nextVod.id + '/' + thiz.nextVod.urlName)
      }
    })

    this.nextVideoEl.addEventListener("click", event => {
      if (!this.isDesktop) {
        thiz.router.navigateByUrl('contentDetail/' + thiz.nextVod.id + '/' + thiz.nextVod.urlName)
      }
    })

  }


  playTrailer() {
    setTimeout(() => {
      this.player = videojs('trailer-player', {
        autoplay: true,
        controls: false,
        fluid: true,
      });
      this.player.poster(this.posterCatalog);
      if (this.content.encodedTrailerUrl)
        this.player.src([
          { src: this.content.encodedTrailerUrl }
        ]);
      else if (this.content.externalTrailerUrl) {
        this.player.src([
          { src: this.content.externalTrailerUrl }
        ]);
      }

    });
  }

  destroyPlayer() {
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
  }

  setBookMark() {
    this.dataSource.setBookmark(this.content.id, parseInt(this.player.currentTime()), parseInt(this.player.duration())).subscribe(data => {
    })
  }

  startVod() {
    this.dataSource.startVod(this.content.id).subscribe(data => {
    })
  }

  stopVod() {
    this.dataSource.stopVod(this.content.id).subscribe(data => {
      return data
    })
  }


  //   @HostListener("window:beforeunload", ["$event"]) beforeUnloadHandler(event: Event) {

  // }

  @HostListener("window:beforeunload", ["$event"]) beforeUnloadHandler(event: Event) {
    this.stopVod()
  }

  @HostListener("window:unload", ["$event"]) unloadHandler(event: Event) {
    this.stopVod()
  }

  locationBack() {
    if (!!sessionStorage.getItem("urlhistory") && JSON.parse(sessionStorage.getItem("urlhistory")).length < 2) {
      this.router.navigateByUrl('');
    }
    else {
      this._location.back();
    }
  }

  playPause() {
    if (this.player.paused()) {
      this.player.play();
    } else {
      this.player.pause();
    }

  }

  mute() {
    if (this.player.muted()) {
      this.player.muted(false);
    } else {
      this.player.muted(true);
    }
  }

  playerFullScreen() {
    if (this.player.isFullscreen()) {
      this.player.exitFullscreen();
    } else {
      this.player.requestFullscreen();
    }

  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/vod/content-detail/content-detail.component.ts